import { Grid } from "@mui/material";
import React, { memo } from "react";
import CommonFields from "./PosCommonFields";
import pageStyles from "../../pageStyles";
import TextInput from "../../../common/formElements/TextInput";

const OpiFields = () => {
  const classes = pageStyles();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <TextInput fieldname="attributes.TID" label="POI Device ID*" />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput fieldname="attributes.SiteId" label="Site ID*" />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput fieldname="attributes.WSNo" label="Workstation Number*" />
      </Grid>
      <Grid item xs={12}>
        <hr className={classes.devide} />
      </Grid>
      <CommonFields />
    </Grid>
  );
};

export default memo(OpiFields);
